export default {
  view: state => state.view,
  retrospectiveDay: state => state.retrospectiveDay,
  status: state => state.status,
  filter: state => state.filter,
  filterBy: state => state.filterBy,
  filterByOptions: state => state.filterByOptions,
  typeBy: state => state.filterBy,
  typeByOptions: state => state.typeByOptions,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  startDate: state => state.startDate,
  endDate: state => state.endDate,
  locations: state => state.locations,
  dataListing: state => state.dataListing,
  countDataListing: state => state.countDataListing,
  kpis: state => state.kpis,
  dataCompanyNumberScansOverall: state => state.dataCompanyNumberScansOverall,
  dataCompanyNumberScans: state => state.dataCompanyNumberScans,
  dataCompanyAvgScanTimes: state => state.dataCompanyAvgScanTimes,
  dataPersonalYesterdayScans: state => state.dataPersonalYesterdayScans,
  dataPersonalAvgScans: state => state.dataPersonalAvgScans,
  dataPersonalAvgScanTimes: state => state.dataPersonalAvgScanTimes,
  dataPersonalAvgCycleTimes: state => state.dataPersonalAvgCycleTimes,
  widgetLoaded: state => state.widgetLoaded,
  technicians: state => state.technicians,
  tech: state => state.tech
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js